import React, { useState } from "react";
import Header from "./components/Header";
import GlobeComponent from "./components/globe/GlobeComponent";
import CountryDetails from "./components/globe/CountryDetails";
import "./App.css";

import ExclusiveSection from "./components/ExclusiveSection"

import ComparisonTable from "./components/ComparisonTable"
import FinanceSystemsExplorer from "./components/FinanceSystemsExplorer"


export function ExclusiveContent() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>📊 Advanced Finance Insights</h2>
      <p>Only Degen Den Academy Members can see this.</p>
      <ul>
        <li>Hidden crypto simulations</li>
        <li>Exclusive financial charts</li>
        <li>Member-only tips</li>
      </ul>
    </div>
  );
}

export default function App() {
  const [selectedCountry, setSelectedCountry] = useState("india");
  const [hasAccess, setHasAccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="app">
      <Header />
      <FinanceSystemsExplorer/>
      <div className="main-container">
        <div className="globe-container">
          <GlobeComponent onCountryClick={setSelectedCountry} />
        </div>
        <div className="country-info-container">
          {selectedCountry ? (
            <CountryDetails countryName={selectedCountry} />
          ) : (
            <p style={{ color: "#0f0" }}>
              Click on a country to start simulation
            </p>
          )}
        </div>

        
      </div>

      <ComparisonTable initialCountry= {"India"}/>

      
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <ExclusiveSection />

    </div>
  );
}
